<template>
  <el-card :body-style="{ padding: '20px', height: '100%' }" class="h-full">
    <el-row>
      <el-input
        size="small"
        clearable
        v-model="queryParam.applyDepartment"
        placeholder="申请部门"
        class="w-200px mr-10px"
      >
      </el-input>
      <el-input
        size="small"
        clearable
        v-model="queryParam.applyApplication"
        placeholder="申请应用"
        class="w-200px mr-10px"
      ></el-input>
      <el-input
        size="small"
        clearable
        v-model="queryParam.subscribePublishName"
        placeholder="订阅名称"
        class="w-200px mr-10px"
      ></el-input>
      <el-button type="primary" size="small" @click="searchTableData">搜索</el-button>
      <el-button
        type="primary"
        size="small"
        :disabled="!$hasAccess('create')"
        @click="handleAdd('add')"
        >新增</el-button
      >
      <el-button
        type="danger"
        size="small"
        :disabled="!$hasAccess('delete')"
        @click="batchDelete(selectionList)"
        >删除</el-button
      >
      <el-button
        type="primary"
        size="small"
        :disabled="!$hasAccess('audit')"
        @click="batchAudit(selectionList)"
        >审核</el-button
      >
    </el-row>
    <el-table
      class="mt-20px"
      border
      :data="tableData"
      v-loading="tableLoading"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
      height="calc(100% - 106px)"
      ref="multipleTable"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="序号" type="index" width="55"></el-table-column>
      <el-table-column
        label="申请部门"
        prop="applyDepartment"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="申请应用"
        prop="applyApplicationName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="申请人" prop="applyUserName" show-overflow-tooltip> </el-table-column>
      <el-table-column label="订阅编码" prop="subscribePublishCode" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="订阅名称" prop="subscribePublishName" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="状态" prop="applyStatusName"> </el-table-column>
      <el-table-column :label="`${$t('operate')}`" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            :disabled="!$hasAccess('audit') || scope.row.applyStatus === 1"
            @click="batchAudit([scope.row.detailId])"
            >审核</el-button
          >
          <el-button
            size="mini"
            :disabled="!$hasAccess('read')"
            @click="handleAdd('read', scope.row)"
            >{{ $t('view') }}</el-button
          >
          <el-button
            size="mini"
            :disabled="!$hasAccess('delete')"
            @click="batchDelete([scope.row.detailId])"
            >{{ $t('delete') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px float-right"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      :page-sizes="$pageSizeAll"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
    ></el-pagination>

    <!-- 新增订阅申请 -->
    <addSubscriptionApp :dialogForm="dialogForm" @refresh="searchTableData" />
  </el-card>
</template>

<script>
import SubscriptionApplicationService from '@/services/SubscriptionApplicationService'
import addSubscriptionApp from './components/addSubscriptionApp'

export default {
  name: 'subscriptionApplication',
  components: { addSubscriptionApp },
  data() {
    return {
      queryParam: {
        subscribePublishName: '',
        applyApplication: '',
        applyDepartment: '',
      },
      tableData: [],
      tableLoading: false,
      selectionList: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      dialogForm: {
        visible: false,
      },
    }
  },
  methods: {
    // 批量删除
    batchDelete(ids) {
      if (ids.length > 0) {
        this.$confirm('是否确定要删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const res = await SubscriptionApplicationService.delSubscribeApply(ids)
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.searchTableData()
          }
        })
      } else {
        this.$message.warning('请选择要删除的数据')
      }
    },
    // 批量审核
    async batchAudit(ids) {
      if (ids.length > 0) {
        const res = await SubscriptionApplicationService.approved(ids)
        if (res && res.code === 0) {
          this.$message.success('审核通过')
          this.searchTableData()
        }
      } else {
        this.$message.warning('请选择要审核的数据')
      }
    },
    handleSelectionChange(val) {
      this.selectionList = _.map(val, (item) => {
        return item.detailId
      })
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.searchTableData()
    },
    async searchTableData() {
      const res = await SubscriptionApplicationService.getList({
        SubscribePublishName: this.queryParam.subscribePublishName,
        ApplyApplication: this.queryParam.applyApplication,
        ApplyDepartment: this.queryParam.applyDepartment,
        Sorting: '',
        SkipCount: (this.page.pageNo - 1) * this.page.pageSize,
        MaxResultCount: this.page.pageSize,
      })
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    handleAdd(type, row) {
      this.dialogForm.type = type
      if (type === 'add') {
        this.dialogForm.visible = true
      } else {
        this.dialogForm.id = row.id
        this.dialogForm.detailId = row.detailId
        this.dialogForm.visible = true
      }
    },
  },
  created() {
    this.searchTableData()
  },
}
</script>
